<template>
  <div>
    <Loader :isLoading="isLoading_public" />
    <div>
      <Header v-if="!viewColidee" :window="window" :parameters="'client'" />
      <div
        :class="
          !viewColidee
            ? window.width < 480
              ? 'has-text-centered container-fluid'
              : 'has-text-centered container'
            : null
        "
      >
        <!-- bandeau -->
        <div
          v-if="!viewColidee"
          class="background"
          :style="
            background + ';height:' + (window.width > 1023 ? '250px' : '125px;')
          "
        >
          <h2 style="font-size:24px;color:white; font-weight:lighter">
            {{ sondage_name }}
          </h2>
        </div>
        <!-- title -->
        <div
          v-if="viewColidee"
          style="padding:4px;margin-top:-4px;"
          class="bloc"
        >
          <p style="text-align:left;font-size:16px;">{{ sondage_name }}</p>
        </div>
        <!-- Choose Your language -->
        <ChoosenLanguage v-if="showChoosenLanguageComponent" />
        <!-- FORM SIMPLE -->
        <SondageFormSimple
          :colidee="colidee"
          :viewColidee="viewColidee"
          v-show="!showChoosenLanguageComponent"
          v-if="type_formulaire === 'simple'"
          :sondage_thanks="sondage_thanks"
          :sondage_presentation="sondage_presentation"
          :sondage_id="sondage_id"
          :sondage_type="sondage_type"
          :urlparticipant="urlparticipant"
          :window="window"
        />
        <!-- FORM AVEC SECTIONS -->
        <SondageFormSection
          :viewColidee="viewColidee"
          :colidee="colidee"
          v-show="!showChoosenLanguageComponent"
          v-if="type_formulaire === 'section'"
          :sondage_thanks="sondage_thanks"
          :sondage_presentation="sondage_presentation"
          :sondage_id="sondage_id"
          :sondage_type="sondage_type"
          :window="window"
          :urlparticipant="urlparticipant"
        />
        <br /><br /><br /><br />
      </div>
      <MyFooter v-if="!viewColidee" :window="window" />
    </div>
  </div>
</template>

<script>
import MyFooter from '@/components/layout/MyFooter'
import Loader from '@/components/layout/Loader'
import SondageFormSimple from '@/components/formulaire/formulaire_simple/SondageFormSimple'
import SondageFormSection from '@/components/formulaire/formulaire_section/SondageFormSection'
import ChoosenLanguage from '@/components/formulaire/ChoosenLanguage'
import Header from '@/components/layout/Header'
import axios from 'axios'
import { mapGetters } from 'vuex'
import EventBus from '@/eventBus'

export default {
  data () {
    return {
      sondage_name: '',
      sondage_type: '',
      sondage_id: '',
      background: '',
      languages: null,
      showChoosenLanguageComponent: false,
      selectedLanguage: false,
      url_sondage: process.env.URL_MEDIA,
      urlparticipant: this.$route.params.urlparticipant,
      sondage_thanks: '',
      sondage_presentation: '',
      window: {
        width: 0
      },
      viewColidee: false,
      colidee: null
    }
  },
  components: {
    SondageFormSimple,
    SondageFormSection,
    MyFooter,
    Loader,
    ChoosenLanguage,
    Header
  },
  computed: {
    ...mapGetters([
      'type_formulaire',
      'isLoading_public',
      'configure_questions_sondage_name'
    ])
  },
  created () {
    let message = {
      height: document.body.scrollHeight
    }
    window.top.postMessage(message, '*')
    window.addEventListener('resize', this.handleResize)
    this.handleResize()
    EventBus.$on(
      'choosenLanguageComponentEmit',
      this.showChoosenLanguageComponentFunction
    )
  },
  beforeDestroy () {
    EventBus.$off('choosenLanguageComponentEmit')
  },
  destroyed () {
    window.removeEventListener('resize', this.handleResize)
  },
  methods: {
    handleResize () {
      this.window.width = window.innerWidth
    },
    showChoosenLanguageComponentFunction (params) {
      if (this.languages.length > 1 && params === true) {
        this.showChoosenLanguageComponent = true
      } else {
        this.showChoosenLanguageComponent = false
      }
    }
  },
  mounted () {
    axios.defaults.headers.common['urlparticipant'] = JSON.stringify({'urlParticipant': this.urlparticipant, 'authorizedPreview': this.$store.getters.authorizedPreview, 'colideeViewResultsClient': 'false'})
    axios
      .get(process.env.URL_SSO_API + 'sondage/checkurlparticipant')
      .then(response => {
        if (!this.$store.getters.authorizedPreview) {
          if (response.data[0].state) {
            if (
              (response.data[0].open_at !== '1970-01-01 00:00:00' &&
                response.data[0].open_at !== null) ||
              (response.data[0].close_at !== '1970-01-01 00:00:00' &&
                response.data[0].close_at !== null)
            ) {
              if (
                response.data[0].open_at !== '1970-01-01 00:00:00' &&
                response.data[0].open_at !== null &&
                new Date(response.data[0].open_at.replace(' ', 'T')) >=
                  new Date()
              ) {
                this.$buefy.toast.open({
                  type: 'is-danger',
                  message: this.$i18n.t('toast.sondage_invalide')
                })
                this.$router.push({ name: 'home' })
              } else if (
                response.data[0].close_at !== '1970-01-01 00:00:00' &&
                response.data[0].close_at !== null &&
                new Date(response.data[0].close_at.replace(' ', 'T')) <=
                  new Date()
              ) {
                this.$buefy.toast.open({
                  type: 'is-danger',
                  message: this.$i18n.t('toast.sondage_invalide')
                })
                this.$router.push({ name: 'home' })
              }
            }
          } else {
            this.$buefy.toast.open({
              type: 'is-danger',
              message: this.$i18n.t('toast.sondage_invalide')
            })
            this.$router.push({ name: 'home' })
          }
        }
        if (
          response.data[0].id_entreprise !== null &&
          response.data[0].id_plateforme !== null
        ) {
          this.viewColidee = true
          this.colidee = {
            enterprise: response.data[0].id_entreprise,
            plateforme: response.data[0].id_plateforme
          }
        }
        this.sondage_name = response.data[0].name
        this.sondage_type = response.data[0].type
        this.sondage_id = response.data[0].id
        this.languages = JSON.parse(response.data[0].languages)
        this.$store.commit(
          'SHOW_RESULTS_CLIENT',
          response.data[0].show_results_client
        )
        this.$store.commit(
          'UPDATE_LANGUAGES_QUESTIONS_ADMIN',
          JSON.parse(response.data[0].languages)
        )
        // condition to show "choosenLanguage" component et choosen language if only one language
        if (this.languages.length) {
          if (this.viewColidee) {
            this.$i18n.locale = this.$route.params.languageColidee
          }
          if (this.languages.length > 1) {
            this.showChoosenLanguageComponent = true
          } else {
            this.showChoosenLanguageComponent = false
            this.$store.commit(
              'UPDATE_CHOOSEN_LANGUAGE_CLIENT',
              this.languages[0]
            )
            if (this.viewColidee) {
              this.$i18n.locale = this.$route.params.languageColidee
            } else {
              this.$i18n.locale = this.languages[0]
            }
          }
        } else {
          if (this.viewColidee) {
            this.$i18n.locale = this.$route.params.languageColidee
          } else {
            this.$i18n.locale = this.languages[0]
          }
        }
        this.sondage_thanks = response.data[0].thanks
        this.sondage_presentation = response.data[0].presentation
        if (this.sondage_presentation) {
          this.$store.commit('UPDATE_SHOW_SONDAGE_PRESENTATION', true)
        }
        if (response.data[0].media) {
          this.background =
            "background-size: cover;background-image:url('" +
            this.url_sondage +
            response.data[0].media +
            "')"
        } else {
          this.background =
            'background-size: cover;background-image:url(' +
            require('@/assets/img/bandeau/bandeau.jpg') +
            ')'
        }
        // on regarde si il est admin
        if (this.$store.getters.authorizedPreview) {
          console.log(this.urlparticipant, 'this.urlparticipant')
          this.$store.dispatch('getQuestionsPublic', {
            urlparticipant: this.urlparticipant,
            idSondage: this.sondage_id
          })
        } else {
          // on regarde si le sondage est de type block,  si c'est le cas on regarde si le terminal a déjà répondu
          if (this.sondage_type == 'block') {
            if (
              window.store.getters.sondage_repondu.indexOf(this.sondage_id) > -1
            ) {
              if (this.viewColidee) {
                let message = {
                  eventColidee: 'dejaRepondu'
                }
                window.top.postMessage(message, '*')
              } else {
                this.$buefy.toast.open({
                  type: 'is-danger',
                  message: this.$i18n.t('toast.deja_repondu')
                })
                this.$router.push({ name: 'home' })
              }
            } else {
              // si pas encore répondu on lui propose les questions
              this.$store.dispatch('getQuestionsPublic', {
                urlparticipant: this.urlparticipant,
                idSondage: this.sondage_id
              })
            }
          } else {
            // sinon on laisse passer
            this.$store.dispatch('getQuestionsPublic', {
              urlparticipant: this.urlparticipant,
              idSondage: this.sondage_id
            })
          }
        }
      })
      .catch(error => {
        this.$buefy.toast.open({
          type: 'is-danger',
          message: this.$i18n.t('toast.sondage_invalide')
        })
        // this.$router.push({ name: 'home' })
      })
  }
}
</script>

<style scoped>
.background {
  margin-top: 5px;
  background-repeat: no-repeat;
  background-position: center;
}
</style>



// WEBPACK FOOTER //
// src/components/page/Repondre.vue